<template>
  <div v-if="!isPreview" class="image-container" :style="style">
    <div class="button-layer">
      <div class="button-container">
        <i class="material-symbols-outlined align-middle">audio_file</i>
      </div>
    </div>
  </div>
  <audio
    v-else
    :ref="`playlist_audio_widget_${widget.object.item_id}`"
    muted
    loop
    controls
    :class="['playlist-slide-audio']"
    :style="style"
  >
    <source :src="getEncodedURL(baseUrl, widget.object.item_url)" :type="widget.object.item_type" />
    Your browser does not support the audio extension.
  </audio>
</template>

<script>
  import templateWidget from '@/components/templates/mixins/templateWidget';
  import { simpleTypeMixin } from '@/helpers';
  import { mapState } from 'vuex';

  export default {
    name: 'AudioWidget',

    mixins: [templateWidget, simpleTypeMixin],

    props: {
      widget: {
        type: Object,
        default: () => ({}),
      },
    },

    mounted() {
      const audioRef = this.$refs[`playlist_audio_widget_${this.widget.object.item_id}`];

      if (audioRef) {
        audioRef.volume = this.widget.object.volume;
        audioRef.muted = this.widget.object.mute;
        audioRef.play();
      }
    },

    computed: {
      ...mapState({
        isPreview: (state) => state.preview.isPreview,
      }),

      style() {
        const style = this.defaultStyling(this.widget);

        return {
          ...style,
          position: 'absolute',
        };
      },
    },
  };
</script>

<style lang="scss" scoped>
  .image-container {
    background-color: $fillGrey;
    position: relative;
    cursor: pointer;
    width: 100%;
    height: 100%;

    .button-layer {
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 2;
      width: 100%;
      height: 100%;

      .button-container {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 64px;
        height: 64px;

        border-radius: 100%;
        background: rgba(255, 255, 255, 0.45);
        border: 2px solid rgba(255, 255, 255, 0.15);

        i {
          font-size: 32px;
          color: $primaryRed;
        }
      }
    }
  }
</style>
